// Lightweight analytics wrapper around Plausible.
//
// The Plausible snippet is loaded in public/index.html, which exposes a
// global `window.plausible(eventName, { props: {...} })` function. This
// module gives the rest of the app a stable `trackEvent` API so we can
// swap providers later without touching every call site.

export function initAnalytics() {
  // Plausible self-initialises via its script tag in index.html.
  // Kept as a no-op so existing App.js import keeps working.
}

export function trackEvent(name, params = {}) {
  if (typeof window === "undefined") return;

  if (typeof window.plausible === "function") {
    window.plausible(name, { props: params });
  }

  if (process.env.NODE_ENV !== "production") {
    // eslint-disable-next-line no-console
    console.debug("[analytics]", name, params);
  }
}
